import _ from "lodash";
import { createSelector } from "reselect";

export const getQueryParams = state => {
    return _.get(state, "queryParams.queryParams", {});
};

export const getParamsClientMac = createSelector([getQueryParams], queryParams => {
    return _.get(queryParams, "client_mac");
});